import React, { useEffect, useState } from "react";
import TableContainer from "../../Component/TableContainer";
import { Box, Checkbox, IconButton, Typography, Paper, Grid, Button, Select, MenuItem, Switch, Autocomplete, CircularProgress, createFilterOptions, TextField, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { masterAPI } from "../../Pages/Masters/dataConfig";
import { axiosPrivate } from "../../axios/axios";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
  RemoveRedEye,
} from "@mui/icons-material";
import { color } from "../../StyleData/Config";

import NormalTable from "../../Component/NormalTable";
import KPIHour from "../Dashboard/KPIHour";

import ResponsiveDialog from "../../Component/ResponsiveDialog";
import KPIModal from "./KPIModal";
const KPI = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [menusId, setMenusId] = useState([]);
  const [editData, setEditData] = useState({});
  const [editOpen, setEditOpen] = useState(false);
  const [kpiDialog, setKpiDialog] = useState({
    isOpen: false,
    kpiName: "",
    apiEndpoint: "",
    listApiEndpoint: "",
  });

  useEffect(() => {
    getData();
  }, []);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const getData = async () => {
    setLoading(true);
    const link = masterAPI["kpimaster"].link;
    try {
      const res = await axiosPrivate.get(`${link}`);
      setMenusId(res.data.result);
    } catch (e) {
      console.log(e, "kpimaster");
      setMenusId([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (data) => {
    setEditData(data);
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setEditData({});
    getData();
  };

  const handleKPIView = (kpiName) => {
    if (kpiName === "Preventive Maintenance Hour") {
      setKpiDialog({
        isOpen: true,
        kpiName: kpiName,
        apiEndpoint: masterAPI.KPIReport.getPreventiveMaintenanceHourKPIData,
        listApiEndpoint: masterAPI.KPIReport.getPreventiveMaintenanceHourKPIList,
      });
    }
  };

  const columns = [
    {
      accessor: "dashboardName",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "inherit", fontWeight: "600" }}>
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const isPreventiveMaintenance =
          cell.row.original.dashboardName === "Preventive Maintenance Hour";

        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={!cell.row.original.isTarget}
              onClick={() => handleEdit(cell.row.original)}
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                }}
              />
            </IconButton>
            <IconButton
              disabled={!isPreventiveMaintenance}
              onClick={() =>
                isPreventiveMaintenance &&
                handleKPIView(cell.row.original.dashboardName)
              }
            >
              <RemoveRedEye
                sx={{
                  fontSize: color.masterEditDelButton,
                  //color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          KPI
        </Typography>
      </Box>

      <Paper sx={{ p: 1 }}>
        <Grid container spacing={"1rem"}>
          <Grid item xs={12}>
            <NormalTable data={menusId} columns={columns} />
          </Grid>
        </Grid>
      </Paper>

      <ResponsiveDialog
        open={kpiDialog.isOpen}
        onClose={() => setKpiDialog({ ...kpiDialog, isOpen: false })}
        PaperProps={{
          sx: {
            maxWidth: { xs: "100vw", md: "90vw" },
            width: { xs: "100vw", md: "85vw" },
          },
        }}
      >
        <DialogTitle>{kpiDialog.kpiName}</DialogTitle>
        <Divider />
        <DialogContent sx={{ minHeight: "400px", p: 2 }}>
          {kpiDialog.apiEndpoint && (
            <KPIHour
              apiEndpoint={kpiDialog.apiEndpoint}
              listApiEndpoint={kpiDialog.listApiEndpoint}
              title={kpiDialog.kpiName}
              showDateColumns={true}
            />
          )}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setKpiDialog({ ...kpiDialog, isOpen: false })}
            variant="contained"
            sx={{ backgroundColor: "#2362B4", color: "white" }}
          >
            Close
          </Button>
        </DialogActions>
      </ResponsiveDialog>

      <ResponsiveDialog
        open={editOpen}
        onClose={handleEditClose}
        maxWidth={"lg"}
        children={
          <KPIModal handleCloseClick={handleEditClose} editData={editData} />
        }
      />
    </>
  );
};

export default KPI;
